<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div slot="header">
            <strong>Thông tin sản phẩm</strong>
          </div>
          <b-form @submit.prevent="save">
            <b-row>
              <b-col>
                <b-form-group
                  label="Danh mục sản phẩm:"
                  label-for="categoryIds"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <treeselect
                    :multiple="true"
                    class="col-10 no-padding"
                    v-if="editing && categories.length > 0"
                    v-model="product.categoryIds"
                    placeholder="--- Chọn ---"
                    :options="categories"
                  />
                  <label v-if="!editing" class="col-form-label col-10">
                    {{ product.categoryName }}
                  </label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Mã sản phẩm:"
                  label-for="code"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="code"
                    class="col-10"
                    v-if="editing"
                    aria-describedby="codeFeedback"
                    v-model="$v.product.code.$model"
                    :state="
                      $v.product.code.$dirty ? !$v.product.code.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập mã sản phẩm
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.code
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tiêu đề sản phẩm:"
                  label-for="title"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <b-form-input
                    type="text"
                    id="title"
                    class="col-10"
                    v-if="editing"
                    aria-describedby="codeFeedback"
                    v-model="$v.product.title.$model"
                    :state="
                      $v.product.title.$dirty ? !$v.product.title.$error : null
                    "
                  >
                  </b-form-input>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên sản phẩm
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.title
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tên không dấu:"
                  label-for="slug"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    id="slug"
                    v-if="editing"
                    class="col-10"
                    aria-describedby="codeFeedback"
                    v-model="product.slug"
                  >
                  </b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.slug
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Mô tả:"
                  label-for="description"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                >
                  <!--<b-form-input type="text" id="description"
                                                  class="col-10"
                                                  v-if="editing"
                                                  aria-describedby="codeFeedback"
                                                  v-model="$v.product.description.$model"
                                                  :state="$v.product.description.$dirty? !$v.product.description.$error : null">
                                    </b-form-input>-->
                  <b-form-textarea
                    id="description"
                    v-model="$v.product.description.$model"
                    :state="
                      $v.product.description.$model &&
                      $v.product.description.$dirty
                        ? !$v.product.description.$error
                        : null
                    "
                    v-if="editing"
                    class="col-10"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback id="codeFeedback">
                    Vui lòng nhập tên sản phẩm
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.description
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <!-- <b-row>
              <b-col>
                <b-form-group
                  label="Chi tiết:"
                  label-for="detail"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  :label-class="editing ? 'required' : ''"
                  id="editor-css"
                >
                  <b-col md="10" class="no-padding" v-if="editing">
                    <b-form-input
                      type="text"
                      style="display: none"
                      aria-describedby="codeFeedback"
                      v-model="$v.product.detail.$model"
                      :state="
                        $v.product.detail.$dirty
                          ? !$v.product.detail.$error
                          : null
                      "
                    >
                    </b-form-input>
                    <DocumentEditor
                      ref="doc"
                      v-model="product.detail"
                    ></DocumentEditor>
                    <b-form-invalid-feedback v-if="!$v.product.detail.required">
                      Vui lòng nhập chi tiết !
                    </b-form-invalid-feedback>
                  </b-col>
                  <label
                    class="col-form-label col-10"
                    v-if="!editing"
                    v-html="product.detail"
                  ></label>
                </b-form-group>
              </b-col>
            </b-row> -->

<b-row>
              <b-col>
                <b-form-group
                  label="Chi tiết:"
                  label-for="detail"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                  id="editor-css"
                >
                  <b-col md="10" class="no-padding" v-if="editing">
                    <DocumentEditor
                      ref="doc"
                      v-model="product.detail"
                    ></DocumentEditor>
                  </b-col>
                  <label
                    class="col-form-label col-10"
                    v-if="!editing"
                    v-html="product.detail"
                  ></label>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <b-row>
                            <b-col>
                                <b-form-group label="Đường dẫn hình ảnh:"
                                              label-for="urlImage"
                                              :label-cols="2"
                                              :horizontal="true"
                                              label-align="right">
                                    <b-form-file v-model="product.files"
                                                 class="col-10 no-padding"
                                                 accept="image/*"
                                                 browse-text="Chọn"
                                                 multiple
                                                 v-if="editing"
                                                 placeholder="Chọn tệp tải lên...">
                                        <template slot="file-name" slot-scope="{ names }">
                                            <b-badge variant="dark">{{ names[0] }}</b-badge>
                                            <b-badge v-if="names.length > 1" variant="dark" class="ml-1">
                                                + {{ names.length - 1 }} tệp khác
                                            </b-badge>
                                        </template>
                                    </b-form-file>
                                    <label class="col-form-label col-10" v-if="(product.files == undefined || product.files.length == 0) && !editing">{{product.urlImage}}</label>
                                </b-form-group>
                            </b-col>
                        </b-row> -->
            <b-row>
              <b-col>
                <b-form-group
                  label="Đường dẫn video:"
                  label-for="urlVideo"
                  :label-cols="2"
                  :horizontal="true"
                  label-align="right"
                >
                  <b-form-input
                    type="text"
                    id="urlVideo"
                    v-if="editing"
                    class="col-10"
                    aria-describedby="urlVideoFeedback"
                    v-model="product.urlVideo"
                  >
                  </b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.urlVideo
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Chủ đầu tư:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoInvestor"
                    class="col-10"
                    id="InfoInvestor"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoInvestor
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Địa chỉ:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoAddress"
                    class="col-10"
                    id="infoAddress"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoAddress
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Diện tích:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoArea"
                    class="col-10"
                    id="infoArea"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoArea
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số tầng:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoFloorNumber"
                    class="col-10"
                    id="infoFloorNumber"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoFloorNumber
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Số mặt tiền:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoFacadeNumber"
                    class="col-10"
                    id="infoAddress"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoFacadeNumber
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Gara:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoGarage"
                    class="col-10"
                    id="infoGarage"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoGarage
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Phong cách:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoStyle"
                    class="col-10"
                    id="infoStyle"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoStyle
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Thời gian thực hiện:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoExecutionDate"
                    class="col-10"
                    id="infoExecutionDate"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoExecutionDate
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Đơn vị thiết kế:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoDesignUnit"
                    class="col-10"
                    id="infoDesignUnit"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoDesignUnit
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Tổng thành tiền:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input
                    v-model="product.infoTotalCost"
                    class="col-10"
                    id="infoTotalCost"
                    rows="3"
                    v-if="editing"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoTotalCost
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Công năng:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="product.infoPerformanceInfo"
                    class="col-10"
                    id="InfoPerformanceInfo"
                    rows="3"
                    v-if="editing"
                  ></b-form-textarea>
                  <label class="col-form-label col-10" v-else>{{
                    product.infoPerformanceInfo
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="MetaTitle:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaTitle.$model"
                    :state="
                      $v.product.metaTitle.$model && $v.product.metaTitle.$dirty
                        ? !$v.product.metaTitle.$error
                        : null
                    "
                    v-if="editing"
                    class="col-10"
                    id="MetaTitle"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaTitle.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.metaTitle
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaKeywords:"
                  label-for="MetaKeywords"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaKeywords.$model"
                    :state="
                      $v.product.metaKeywords.$model &&
                      $v.product.metaKeywords.$dirty
                        ? !$v.product.metaKeywords.$error
                        : null
                    "
                    v-if="editing"
                    class="col-10"
                    id="MetaKeywords"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaKeywords.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.metaKeywords
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="MetaDescriptions:"
                  label-for="MetaDescriptions"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-textarea
                    v-model="$v.product.metaDescriptions.$model"
                    :state="
                      $v.product.metaDescriptions.$model &&
                      $v.product.metaDescriptions.$dirty
                        ? !$v.product.metaDescriptions.$error
                        : null
                    "
                    v-if="editing"
                    class="col-10"
                    id="MetaDescriptions"
                    rows="3"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    v-if="!$v.product.metaDescriptions.maxLength"
                  >
                    Không được quá 256 ký tự !
                  </b-form-invalid-feedback>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.metaDescriptions
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Số lượng ảnh trình chiếu:"
                  label-for="name"
                  :label-cols="2"
                  label-align="right"
                  :horizontal="true"
                >
                  <b-form-input v-if="editing"
                    v-model="product.numberSlider"
                    type="number"
                    class="col-10"
                  ></b-form-input>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    product.numberSlider
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <b-form-group
                  label="Trạng thái:"
                  label-align="right"
                  label-for="status"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="status"
                    v-if="editing"
                    v-model="product.status"
                    class="col-10 col-form-label"
                  ></b-form-checkbox>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    $store.getters.getStatusName(product.status ? 1 : 0)
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group
                  label="Ưu tiên hiển thị:"
                  label-align="right"
                  label-for="isPrioritizeShow"
                  :label-cols="2"
                  :horizontal="true"
                >
                  <b-form-checkbox
                    id="isPrioritizeShow"
                    v-if="editing"
                    v-model="product.isPrioritizeShow"
                    class="col-10 col-form-label"
                  ></b-form-checkbox>
                  <label class="col-form-label col-10" v-if="!editing">{{
                    $store.getters.getStatusName(
                      product.isPrioritizeShow ? 1 : 0
                    )
                  }}</label>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="" :label-cols="2">
                  <!--<b-button type="button" variant="primary" @click="edit" v-if="!editing ">Sửa</b-button>-->
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="back"
                    v-if="!editing"
                    >Quay lại</b-button
                  >
                  <b-button
                    type="submit"
                    variant="primary"
                    v-if="editing && authorize(['ManageProduct'])"
                    >Ghi lại</b-button
                  >
                  <b-button
                    type="button"
                    variant="secondary"
                    @click="cancel"
                    v-if="editing"
                    >Hủy</b-button
                  >
                </b-form-group>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { authorizationMixin } from "@/shared/mixins";

export default {
  name: "productDetail",
  mixins: [validationMixin, authorizationMixin],
  data() {
    return {
      product: {
        categoryIds: [],
      },
      editing: this.$route.meta.editing,
    };
  },
  computed: {
    productId() {
      return this.$route.params.productId;
    },
    ...mapState({
      categories: (state, getters) => getters.categoryTree,
    }),
  },
  validations: {
    product: {
      //name: {
      //    required,
      //    maxLength: maxLength(128)
      //},
      title: {
        required,
      },
      description: {
        required,
      },
      // detail: {
      //   required,
      // },
      //categoryIds: {
      //    required,
      //},
      // urlImage: {
      //     required,
      // },
      code: {
        required,
      },
      metaTitle: {
        maxLength: maxLength(256),
      },
      metaKeywords: {
        maxLength: maxLength(256),
      },
      metaDescriptions: {
        maxLength: maxLength(256),
      },
    },
  },
  watch: {
    //'unitType.code'(newVal) {
    //    this.checkExistCode(newVal);
    //}
    "product.title"(value) {
      this.product.slug = value.convertslug();
    },
  },
  created() {
    this.loadproductDetail();
  },
  mounted() {
    const element = document.getElementById("editor-css");
    element.querySelector(".bv-no-focus-ring").classList.add("col-md-10");
  },
  methods: {
    loadproductDetail() {
      var vm = this;
      return this.$services
        .get(`master-data/products/${this.productId}`)
        .done((product) => {
          vm.product = product;
        });
    },
    edit() {
      this.editing = true;
    },
    back() {
      this.$router.push({ path: "/master-data/products" });
    },
    cancel() {
      var vm = this;
      this.loadproductDetail().done(() => (vm.editing = false));
    },
    save() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        var vm = this;
        this.$services.upload(`master-data/products`, this.product).done(() => {
          vm.$toastr.s("Cập nhật sản phẩm thành công");
          vm.cancel();
        });
      }
    },
    checkExistCode(newVal) {
      if (newVal) {
        //var vm = this;
        //this.$services.get(`master-data/existing-unit-types-code/${newVal}/${this.unitType.id || null}`).done(returnData => {
        //    if (!returnData) {
        //        this.codeUnique = "required";
        //    }
        //    else {
        //        this.codeUnique = "";
        //    }
        //});
      } else {
        this.codeUnique = "required";
      }
    },
  },
};
</script>
<style>
/*  .ck-editor__editable {
        min-height: 500px;
    }*/
.ck-editor .ck-editor__main .ck-content {
  min-height: 200px;
}

.ck-editor__editable_inline {
  min-height: 200px;
}
</style>
